import '@poppanator/sveltekit-svg/dist/svg.d.ts'

export const iconMap = {
	ai: () => import('./ai-mark.svg?component'),
	arrowLeft: () => import('./arrow-left.svg?component'),
	arrowRight: () => import('./arrow-right.svg?component'),
	arrowLeftBold: () => import('./arrow-left-bold.svg?component'),
	arrowRightBold: () => import('./arrow-right-bold.svg?component'),
	arrowDown: () => import('./arrow-down.svg?component'),
	arrowUp: () => import('./arrow-up.svg?component'),
	arrowsUpDownLeftRight: () => import('./arrows-up-down-left-right.svg?component'),
	arrowsLeft: () => import('./arrows-left.svg?component'),
	caretUp: () => import('./caret-up.svg?component'),
	caretDown: () => import('./caret-down.svg?component'),
	move: () => import('./move.svg?component'),
	bold: () => import('./bold.svg?component'),
	bulletList: () => import('./bullet-list.svg?component'),
	calendar: () => import('./calendar.svg?component'),
	chevronDown: () => import('./chevron-down.svg?component'),
	chevronUp: () => import('./chevron-up.svg?component'),
	chevronLeft: () => import('./chevron-left.svg?component'),
	chevronRight: () => import('./chevron-right.svg?component'),
	close: () => import('./close.svg?component'),
	closeThin: () => import('./close-thin.svg?component'),
	code: () => import('./code.svg?component'),
	draggable: () => import('./draggable.svg?component'),
	eye: () => import('./eye.svg?component'),
	filter: () => import('./filter.svg?component'),
	fieldError: () => import('./field-error.svg?component'),
	name: () => import('./name.svg?component'),
	plus: () => import('./plus.svg?component'),
	refresh: () => import('./refresh.svg?component'),
	refreshThin: () => import('./refresh-thin.svg?component'),
	search: () => import('./search.svg?component'),
	external: () => import('./external.svg?component'),
	searchLight: () => import('./search-light.svg?component'),
	sharp: () => import('./sharp.svg?component'),
	stars: () => import('./stars.svg?component'),
	trash: () => import('./trash.svg?component'),
	user: () => import('./user.svg?component'),
	quote: () => import('./quote.svg?component'),
	italic: () => import('./italic.svg?component'),
	image: () => import('./image.svg?component'),
	imageSlash: () => import('./image-slash.svg?component'),
	activityStar: () => import('./activity-star.svg?component'),
	activityTermination: () => import('./activity-termination.svg?component'),
	starsFilled: () => import('./stars-filled.svg?component'),
	upload: () => import('./upload.svg?component'),
	view: () => import('./view.svg?component'),
	warning: () => import('./warning.svg?component'),
	zoomIn: () => import('./zoom-in.svg?component'),
	zoomOut: () => import('./zoom-out.svg?component'),
	topic: () => import('./topic.svg?component'),
	checkmark: () => import('./checkmark.svg?component'),
	testFailure: () => import('./test-failure.svg?component'),
	failCircleFill: () => import('./fail-circle-fill.svg?component'),
	failOctagonFill: () => import('./fail-octagon-fill.svg?component'),
	nullCircle: () => import('./null-circle.svg?component'),
	testSuite: () => import('./test-suite.svg?component'),
	subFlow: () => import('./sub-flow.svg?component'),
	success: () => import('./success.svg?component'),
	stopWatch: () => import('./stop-watch.svg?component'),
	stopAudio: () => import('./stop-audio.svg?component'),
	stop: () => import('./stop.svg?component'),
	pause: () => import('./pause.svg?component'),
	pauseOutline: () => import('./pause-outline.svg?component'),
	addUser: () => import('./add-user.svg?component'),
	mute: () => import('./mute.svg?component'),
	record: () => import('./record.svg?component'),
	dropCall: () => import('./drop-call.svg?component'),
	step: () => import('./step.svg?component'),
	start: () => import('./start.svg?component'),
	intentRatingStar: () => import('./intent-rating-star.svg?component'),
	intentRatingStarHalf: () => import('./intent-rating-star-half.svg?component'),
	intentRatingStarEmpty: () => import('./intent-rating-star-empty.svg?component'),
	sort: () => import('./sort.svg?component'),
	translate: () => import('./translate.svg?component'),
	settings: () => import('./settings.svg?component'),
	settingsOutline: () => import('./settings-outline.svg?component'),
	slotFilling: () => import('./slot-filling.svg?component'),
	secondaryChat: () => import('./secondary-chat.svg?component'),
	save: () => import('./save.svg?component'),
	saveOutline: () => import('./save-outline.svg?component'),
	restart: () => import('./restart.svg?component'),
	reorder: () => import('./reorder.svg?component'),
	pdf: () => import('./pdf.svg?component'),
	questionMark: () => import('./question-mark.svg?component'),
	questionMarkOutline: () => import('./question-mark-outline.svg?component'),
	questionMarkFill: () => import('./question-mark-fill.svg?component'),
	query: () => import('./query.svg?component'),
	prompt: () => import('./prompt.svg?component'),
	prequalification: () => import('./prequalification.svg?component'),
	more: () => import('./more.svg?component'),
	milestone: () => import('./milestone.svg?component'),
	unlocked: () => import('./unlocked.svg?component'),
	locked: () => import('./locked.svg?component'),
	lighting: () => import('./lighting.svg?component'),
	lever: () => import('./lever.svg?component'),
	info: () => import('./info.svg?component'),
	gsp: () => import('./gsp.svg?component'),
	grip: () => import('./grip.svg?component'),
	gripBold: () => import('./grip-bold.svg?component'),
	functionContract: () => import('./function-contract.svg?component'),
	functionCall: () => import('./function-call.svg?component'),
	folderClosed: () => import('./folder-closed.svg?component'),
	folderOpened: () => import('./folder-opened.svg?component'),
	file: () => import('./file.svg?component'),
	filePdf: () => import('./file-pdf.svg?component'),
	fileCsv: () => import('./file-csv.svg?component'),
	referenceTable: () => import('./reference-table.svg?component'),
	fileImage: () => import('./file-image.svg?component'),
	mapsTo: () => import('./maps-to.svg?component'),
	fitView: () => import('./fit-view.svg?component'),
	flow: () => import('./flow.svg?component'),
	playAudio: () => import('./play-audio.svg?component'),
	bin: () => import('./bin.svg?component'),
	link: () => import('./link.svg?component'),
	clock: () => import('./clock.svg?component'),
	numberList: () => import('./number-list.svg?component'),
	strikethrough: () => import('./strikethrough.svg?component'),
	branch: () => import('./branch.svg?component'),
	checkCircle: () => import('./check-circle.svg?component'),
	checkCircleFill: () => import('./check-circle-fill.svg?component'),
	chat: () => import('./chat.svg?component'),
	comment: () => import('./comment.svg?component'),
	phone: () => import('./phone.svg?component'),
	phoneTransfer: () => import('./phone-transfer.svg?component'),
	constraint: () => import('./constraint.svg?component'),
	customEvent: () => import('./custom-event.svg?component'),
	customType: () => import('./custom-type.svg?component'),
	dummyTopic: () => import('./dummy-topic.svg?component'),
	edgeAnchorNode: () => import('./edge-anchor-node.svg?component'),
	edgePlus: () => import('./edge-plus.svg?component'),
	copy: () => import('./copy.svg?component'),
	edit: () => import('./edit.svg?component'),
	end: () => import('./end.svg?component'),
	download: () => import('./download.svg?component'),
	downloadFilled: () => import('./download-filled.svg?component'),
	error: () => import('./error.svg?component'),
	exclamation: () => import('./exclamation.svg?component'),
	expand: () => import('./expand.svg?component'),
	expertise: () => import('./expertise.svg?component'),
	export: () => import('./export.svg?component'),
	undo: () => import('./undo.svg?component'),
	redo: () => import('./redo.svg?component'),
	h1: () => import('./h1.svg?component'),
	h2: () => import('./h2.svg?component'),
	h3: () => import('./h3.svg?component'),
	germanFlag: () => import('./german-flag.svg?component'),
	britishFlag: () => import('./british-flag.svg?component'),
	spanishFlag: () => import('./spanish-flag.svg?component'),
	frenchFlag: () => import('./french-flag.svg?component'),
	greekFlag: () => import('./greek-flag.svg?component'),
	italianFlag: () => import('./italian-flag.svg?component'),
	turkishFlag: () => import('./turkish-flag.svg?component'),
	attachFile: () => import('./attach-file.svg?component'),
	sendMessage: () => import('./send-message.svg?component'),
	like: () => import('./like.svg?component'),
	dislike: () => import('./dislike.svg?component'),
	userAvatar: () => import('./user-avatar.svg?component'),
	smb: () => import('./smb.svg?component'),
	persona: () => import('./persona.svg?component'),
	nlu: () => import('./nlu.svg?component'),
	aiModels: () => import('./ai-models.svg?component'),
	assistantConfig: () => import('./assistant-config.svg?component'),
	preferences: () => import('./preferences.svg?component'),
	logout: () => import('./logout.svg?component'),
	profileLogout: () => import('./profile-log-out.svg?component'),
	document: () => import('./document.svg?component'),
	brain: () => import('./brain.svg?component'),
	cornerTriangle: () => import('./corner-triangle.svg?component'),
	layoutFlow: () => import('./layout-flow.svg?component'),
	radialLayout: () => import('./radial-layout.svg?component'),
	layoutAuto: () => import('./layout-auto.svg?component'),
	threeDots: () => import('./three-dots.svg?component'),
	minus: () => import('./minus.svg?component'),
	importFile: () => import('./import-file.svg?component'),
	minusThin: () => import('./minus-thin.svg?component'),
	collapse: () => import('./collapse.svg?component'),
	fullScreen: () => import('./full-screen.svg?component'),
	faceAngry: () => import('./face-angry.svg?component'),
	faceGrin: () => import('./face-grin.svg?component'),
	faceExpressionless: () => import('./face-expressionless.svg?component'),
	microphone: () => import('./microphone.svg?component'),
	liveSession: () => import('./liveSession.svg?component'),
	testInstance: () => import('./test-instance.svg?component'),
	exportProject: () => import('./export-project.svg?component'),
	key: () => import('./keyIcon.svg?component'),
	userSettings: () => import('./userSettings.svg?component'),
	diamond: () => import('./diamond.svg?component'),
	diamondOutline: () => import('./diamond-outline.svg?component'),
	squareOutline: () => import('./square-outline.svg?component'),
	squareOutlineBold: () => import('./square-outline-bold.svg?component'),
	square: () => import('./square.svg?component'),
	userFill: () => import('./user-fill.svg?component'),
	hourglass: () => import('./hourglass.svg?component'),
	releaseVersion: () => import('./addVersion.svg?component'),
	addVersion: () => import('./addVersion.svg?component'),
	version: () => import('./version.svg?component'),
	dependencies: () => import('./dependencies.svg?component'),
	building: () => import('./building.svg?component'),
	star: () => import('./star.svg?component'),
	setToLargest: () => import('./setToLargest.svg?component'),
	setToSmallest: () => import('./setToSmallest.svg?component'),
	setToMedian: () => import('./setToMedian.svg?component'),
	setToContent: () => import('./setToContent.svg?component'),
	setToMinimum: () => import('./setToMinimum.svg?component'),
	equalizer: () => import('./equalizer.svg?component'),
	dropdownCollapsed: () => import('./dropdown-collapsed.svg?component'),
	openai: () => import('./openai.svg?component'),
	azure: () => import('./azure.svg?component'),
	groq: () => import('./groq.svg?component'),
	gemini: () => import('./gemini.svg?component'),
	jina: () => import('./jina.svg?component'),
	openrouter: () => import('./openrouter.svg?component'),
	voyage: () => import('./voyage.svg?component'),
	import: () => import('./import.svg?component')
}

export type IconName = keyof typeof iconMap
